module.exports = __webpack_public_path__ + "img/yqshixian.ad5c42a1.png";